import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './components/home/home.component';
import { DocumentSignerComponent } from './components/signatures-wrapper/sign/document-signer/document-signer.component';
import { DocumentViewerComponent } from './components/signatures-wrapper/sign/document-viewer/document-viewer.component';
import { SignComponent } from './components/signatures-wrapper/sign/sign.component';
import { SignatoriesAuthComponent } from './components/signatures-wrapper/signatories-auth/signatories-auth.component';
import { SignatoryRequestOtpCodeComponent } from './components/signatures-wrapper/signatories-auth/signatory-request-otp-code/signatory-request-otp-code.component';
import { SignatoryVerifyOtpCodeComponent } from './components/signatures-wrapper/signatories-auth/signatory-verify-otp-code/signatory-verify-otp-code.component';
import { SignaturesWrapperComponent } from './components/signatures-wrapper/signatures-wrapper.component';
import { SignatureLinkInvalidatedComponent } from './components/signatures-wrapper/signature-link-invalidated/signature-link-invalidated.component';
import { AuthGuard } from './guards/auth.guard';
import { HasSignatoryUuidQueryParamGuard } from './guards/has-signatory-uuid-query-param.guard';
import { CompanyBasicInfoResolver } from './resolvers/company-basic-info.resolver';

const routes: Routes = [
  { path: 'home', component: HomeComponent },
  {
    path: 'signatures',
    component: SignaturesWrapperComponent,
    children: [
      {
        path: 'auth',
        component: SignatoriesAuthComponent,
        canActivate: [ HasSignatoryUuidQueryParamGuard ],
        children: [
          { 'path': 'request-otp', component: SignatoryRequestOtpCodeComponent, resolve: { 'basic_info': CompanyBasicInfoResolver } },
          { 'path': 'verify', component: SignatoryVerifyOtpCodeComponent },
          { path: '**', redirectTo: 'request-otp' }
        ]
      },
      { path: 'invalidated', component: SignatureLinkInvalidatedComponent },
      {
        path: ':signature_uuid',
        component: SignComponent,
        canActivate: [ AuthGuard ],
        children: [
          { 'path': 'view', component: DocumentViewerComponent },
          { 'path': 'view/:signatory_uuid', component: DocumentViewerComponent },
          { 'path': 'sign', component: DocumentSignerComponent },
          { path: '**', redirectTo: 'view' }
        ]
      },
      { path: '**', redirectTo: 'auth' }
    ]
  },
  { path: '**', redirectTo: 'home' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
